var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.375 7.79175H10.625C9.87357 7.79175 9.1529 8.09026 8.62155 8.62161C8.0902 9.15297 7.79169 9.87363 7.79169 10.6251V57.3751C7.79169 58.1265 8.0902 58.8472 8.62155 59.3786C9.1529 59.9099 9.87357 60.2084 10.625 60.2084H57.375C58.1265 60.2084 58.8471 59.9099 59.3785 59.3786C59.9098 58.8472 60.2084 58.1265 60.2084 57.3751V10.6251C60.2084 9.87363 59.9098 9.15297 59.3785 8.62161C58.8471 8.09026 58.1265 7.79175 57.375 7.79175Z",
    stroke: "#2B3478",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2742 28.6732L34.5242 32.7107C34.6053 32.7933 34.7046 32.8555 34.8143 32.8925C34.9239 32.9295 35.0407 32.9402 35.1552 32.9236C35.2697 32.9071 35.3787 32.8638 35.4733 32.7972C35.568 32.7307 35.6457 32.6428 35.7 32.5407L45.7442 14.6057L22.8934 19.8332C22.7609 19.863 22.639 19.9282 22.5406 20.0218C22.4423 20.1154 22.3712 20.2339 22.3348 20.3648C22.2985 20.4956 22.2983 20.6338 22.3343 20.7647C22.3703 20.8956 22.4411 21.0143 22.5392 21.1082L28.2059 26.5907M28.2059 26.5907L39.0717 19.3515M28.2059 26.5907L30.3167 28.6732L26.9167 31.4074C26.8299 31.4758 26.7257 31.5188 26.6159 31.5314C26.506 31.5439 26.3949 31.5257 26.2948 31.4786C26.1948 31.4315 26.1099 31.3575 26.0496 31.2648C25.9892 31.1722 25.9559 31.0646 25.9534 30.954V24.4799",
    stroke: "#2B3478",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2292 45.0076V50.2776C49.2292 51.3108 48.8187 52.3017 48.0881 53.0323C47.3575 53.7629 46.3666 54.1734 45.3334 54.1734C44.8221 54.1733 44.316 54.0718 43.8443 53.8748C43.3726 53.6779 42.9446 53.3893 42.585 53.0259",
    stroke: "#2B3478",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2292 38.5901V45.0076C49.2292 45.5192 49.1284 46.0258 48.9326 46.4985C48.7368 46.9711 48.4499 47.4006 48.0881 47.7624C47.7263 48.1241 47.2969 48.4111 46.8242 48.6069C46.3515 48.8027 45.8449 48.9034 45.3333 48.9034C44.3001 48.9034 43.3092 48.493 42.5786 47.7624C41.848 47.0317 41.4375 46.0408 41.4375 45.0076V38.5901",
    stroke: "#2B3478",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8958 45.0076C37.8958 45.5192 37.795 46.0258 37.5993 46.4985C37.4035 46.9711 37.1165 47.4006 36.7548 47.7624C36.393 48.1241 35.9635 48.4111 35.4909 48.6069C35.0182 48.8027 34.5116 48.9034 34 48.9034C32.9667 48.9034 31.9758 48.493 31.2452 47.7624C30.5146 47.0317 30.1042 46.0408 30.1042 45.0076V42.5001C30.1023 41.9873 30.2017 41.4792 30.3966 41.0049C30.5916 40.5306 30.8782 40.0994 31.2402 39.7362C31.6021 39.3729 32.0322 39.0847 32.5058 38.888C32.9794 38.6913 33.4872 38.5901 34 38.5901C34.5128 38.5901 35.0205 38.6913 35.4941 38.888C35.9677 39.0847 36.3978 39.3729 36.7598 39.7362C37.1217 40.0994 37.4084 40.5306 37.6033 41.0049C37.7983 41.4792 37.8977 41.9873 37.8958 42.5001",
    stroke: "#2B3478",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8958 48.9034V38.5901",
    stroke: "#2B3478",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7708 45.0076C18.7708 45.5192 18.8716 46.0258 19.0674 46.4985C19.2632 46.9711 19.5501 47.4006 19.9119 47.7624C20.2737 48.1241 20.7031 48.4111 21.1758 48.6069C21.6485 48.8027 22.1551 48.9034 22.6667 48.9034C23.6999 48.9034 24.6908 48.493 25.4214 47.7624C26.1521 47.0317 26.5625 46.0408 26.5625 45.0076V42.5001C26.5644 41.9873 26.465 41.4792 26.27 41.0049C26.0751 40.5306 25.7884 40.0994 25.4265 39.7362C25.0645 39.3729 24.6344 39.0847 24.1608 38.888C23.6872 38.6913 23.1795 38.5901 22.6667 38.5901C22.1539 38.5901 21.6461 38.6913 21.1725 38.888C20.6989 39.0847 20.2688 39.3729 19.9069 39.7362C19.5449 40.0994 19.2583 40.5306 19.0633 41.0049C18.8684 41.4792 18.769 41.9873 18.7708 42.5001",
    stroke: "#2B3478",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7708 38.5901V54.1734",
    stroke: "#2B3478",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/PaymentIcon.dba365d979103acb0f108b498f5b38b0.svg";
export { ForwardRef as ReactComponent };